<app-toolbar-search [isSidenavOpen]="isToShow" [notifications$]="notifications$"
  [hideMenuButton]="mobile && isGuide" [navLocked]="navLocked"
  (toggleSideNavEvent)="toggleSidenav()"></app-toolbar-search>
<mat-sidenav-container [hasBackdrop]="mobile">
  <mat-sidenav #sidenav="" mode="side" [opened]="isToShow" (closedStart)="closedStart()">
    <app-button-toggle-menu [isSideNavOpen]="isToShow" (click)="toggleSidenav()"></app-button-toggle-menu>
    <a [routerLink]="['/client/home']" routerLinkActive="active" (click)="closeSideNav()" data-testid="sidenav-home">
      <img src="assets/icons/home2.svg" class="padded" alt="Dashboard" />
      <span class="animatable-menu-span">{{ "Home" | translate }}</span>
    </a>
    <a [routerLink]="navLocked ? null : ['/client/profile']" [class.disabled]="navLocked" routerLinkActive="active" (click)="closeSideNav()" data-testid="sidenav-profile">
      <img src="assets/icons/user.svg" alt="Profile" />
      <span class="animatable-menu-span">{{ "Profile" | translate }}</span>
    </a>
    <a [routerLink]="navLocked ? null : ['/client/cases']" [queryParams]="{ open: false }" [class.disabled]="navLocked" routerLinkActive="active"
      (click)="closeSideNav()" data-testid="sidenav-cases">
      <img src="assets/icons/cases.svg" alt="Cases" />
      <span class="animatable-menu-span">{{ "Cases" | translate }}</span>
    </a>

    <a [routerLink]="navLocked ? null : ['/client/cases']" routerLinkActive="active" [queryParams]="{ open: true }" [class.disabled]="navLocked"
      (click)="closeSideNav()" data-testid="sidenav-my-claims">
      <img src="assets/icons/my-claims.svg" alt="Claims" />
      <span class="animatable-menu-span">{{ "MyClaims" | translate }} </span>
    </a>
    <a [routerLink]="navLocked ? null : ['/client/messages']" [class.disabled]="navLocked" routerLinkActive="active" (click)="closeSideNav()" data-testid="sidenav-messages">
      <img src="assets/icons/messages.svg" alt="Messages" />
      <span class="animatable-menu-span">{{ "Messages" | translate }}</span>
    </a>
    <a [routerLink]="navLocked ? null : ['/client/news']" [class.disabled]="navLocked" routerLinkActive="active" (click)="closeSideNav()" data-testid="sidenav-news">
      <img src="assets/icons/news.svg" alt="news" />
      <span class="animatable-menu-span">{{ "News" | translate }}</span>
    </a>

    <a [routerLink]="navLocked ? null : ['/client/faq']" [class.disabled]="navLocked" routerLinkActive="active" (click)="closeSideNav()" data-testid="sidenav-faq">
      <img src="assets/icons/faq.svg" alt="FAQ" />
      <span class="animatable-menu-span">{{ "FAQ" | translate }}</span>
    </a>

    <a [routerLink]="['/auth/login']"(click)="logout()" data-testid="sidenav-logout">
      <img src="assets/icons/logout.svg" alt="Logout" />
      <span class="animatable-menu-span">{{ "Logoff" | translate }}</span>
    </a>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>